import { PageMeta } from "../app/PageMeta";
import { CallPreparation } from "../components/CallPreparation/CallPreparation";
import { CompanyMap } from "../components/CompanyMap/CompanyMap";
import { FAQ } from "../components/FAQ/FAQ";
import { FinalCTA } from "../components/FinalCTA/FinalCTA";
import { Footer } from "../components/Footer/Footer";
import { Header } from "../components/Header/Header";
import { Hero } from "../components/Hero/Hero";
import { MobilePhoneCTA } from "../components/MobilePhoneCTA/MobilePhoneCTA";
import { ProofSection } from "../components/ProofSection/ProofSection";
import { PurchaseFlow } from "../components/PurchaseFlow/PurchaseFlow";
import { QuickFacts } from "../components/QuickFacts/QuickFacts";
import { VehicleEligibility } from "../components/VehicleEligibility/VehicleEligibility";
import { siteConfig } from "../content/site";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "AutomotiveBusiness",
  name: siteConfig.businessName,
  telephone: siteConfig.phoneDisplay,
  description:
    "沖縄本島全域で、廃車の電話査定から引き取り、抹消手続きまで対応する松島オートです。",
  areaServed: "沖縄本島",
  address: {
    "@type": "PostalAddress",
    postalCode: "901-2131",
    addressRegion: "沖縄県",
    addressLocality: "浦添市",
    streetAddress: "牧港2丁目8-3",
    addressCountry: "JP",
  },
};

export function HomePage() {
  return (
    <>
      <PageMeta
        title="沖縄本島全域の廃車買取｜松島オート"
        description="沖縄本島全域の廃車買取。電話査定は3分。走らない車やタイヤがない車も、引き取りから抹消手続きまで松島オートが対応します。"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Header isHome />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <QuickFacts />
        <VehicleEligibility />
        <ProofSection />
        <PurchaseFlow />
        <CallPreparation />
        <FAQ />
        {siteConfig.googleReviewsUrl ? (
          <section className="reviews-link section" aria-label="Googleの口コミ">
            <div className="section-shell">
              <a
                href={siteConfig.googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-reviews-link"
              >
                Googleの口コミを見る
                <span className="sr-only">（新しいタブで開きます）</span>
              </a>
            </div>
          </section>
        ) : null}
        <CompanyMap />
        <FinalCTA />
      </main>
      <Footer />
      <MobilePhoneCTA />
    </>
  );
}
